import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import PlantillaScreen from "../../../helpers/PlantillaScreen";

const AgregarObjecionPagoModal = ({ open, onClose }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [objecion, setObjecion] = useState({
        descripcion: "",
        estatus: true,
    });

    const guardarObjecion = () => {
        if (objecion.descripcion === "" || objecion.descripcion === null || objecion.descripcion === undefined) {
            Swal.fire({
                title: "OBJECIONES DE PAGO",
                text: "Debe escribir una descripción para la objeción",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        setLoader({ ...loader, mostrar: true });
        request
            .get(`ObjecionesPago/AgregarObjeciones?objecion=${objecion.descripcion}&usuario=0`)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "OBJECIONES DE PAGO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("OBJECIONES DE PAGO", JSON.stringify(error), "error");
            });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="generar-convenio-modal-formulario">
                    <div className="generar-convenio-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"AGREGAR OBJECION DE PAGO"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`generar-convenio-modal-agregar-convenio`}>
                                    <div className="generar-convenio-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Registrar Objeción de Pago</h3>
                                        {/* <div className="agregar-objecion-modal-estatus">
                                            <input
                                                type="checkbox"
                                                name="convenio"
                                                className="chk-groups"
                                                id="convenio"
                                                checked={objecion.estatus}
                                                onChange={(e) => {
                                                    setObjecion({
                                                        ...objecion,
                                                        estatus: e.target.checked,
                                                    });
                                                }}
                                            />
                                            <span>Estatus</span>
                                        </div> */}
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Objeción"
                                            sx={{ mt: 2 }}
                                            value={objecion.descripcion}
                                            onChange={(e) => {
                                                setObjecion({
                                                    ...objecion,
                                                    descripcion: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="generar-convenio-modal-buttons">
                                        <button
                                            className="generar-convenio-modal-button-guardar"
                                            onClick={() => guardarObjecion()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default AgregarObjecionPagoModal;